module.exports = __webpack_public_path__ + "static/media/logo_2.ce2e16ff.jpg";